import { render, staticRenderFns } from "./ScoreTrend.vue?vue&type=template&id=0aa3105a&scoped=true"
import script from "./ScoreTrend.vue?vue&type=script&lang=js"
export * from "./ScoreTrend.vue?vue&type=script&lang=js"
import style0 from "./ScoreTrend.vue?vue&type=style&index=0&id=0aa3105a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa3105a",
  null
  
)

export default component.exports